/**
 * Project: xpenser-client
 * FilePath: /src/app/store/constants/index.ts
 * File: index.ts
 * Created Date: Friday, September 18th 2020, 6:50:27 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Fri Sep 18 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 */

export const LOGIN_ORIGIN = process.env.REACT_APP_BASE_LOGIN_URL
export const AUTH_ORIGIN = process.env.REACT_APP_BASE_AUTH_URL

const baseLoginPath = process.env.REACT_APP_BASE_LOGIN_PATH
const clientId = process.env.REACT_APP_CLIENT_ID
const responseType = process.env.REACT_APP_RESPONSE_TYPE
const scope = process.env.REACT_APP_SCOPE
const redirectUrl = `${AUTH_ORIGIN}${process.env.REACT_APP_REDIRECT_PATH}`

export const AUTH_VERIFY_URL = `${AUTH_ORIGIN}${process.env.REACT_APP_VERIFY_JWT_PATH}`
export const AUTH_LOGIN_URL = `${LOGIN_ORIGIN}${baseLoginPath}?client_id=${clientId}&response_type=${responseType}&scope=${scope}&redirect_uri=${redirectUrl}`

export default {
  AUTH_VERIFY_URL,
  AUTH_LOGIN_URL
}
